import { UserInformation } from '@/common/hooks/google-tag-manager/use-push-user-information-to-data-layer';

export function generateHashedMetadataPayload({
  user_id,
  hashed_city,
  hashed_country,
  hashed_dob,
  hashed_email,
  hashed_external_id,
  hashed_first_name,
  hashed_last_name,
  hashed_phone,
  hashed_state,
  hashed_zip,
}: UserInformation): Record<string, string> | null {
  const payload = Object.fromEntries(
    Object.entries({
      user_id: user_id,
      user_hashed_city: hashed_city,
      user_hashed_country: hashed_country,
      user_hashed_dob: hashed_dob,
      user_hashed_email: hashed_email,
      user_hashed_first_name: hashed_first_name,
      user_hashed_last_name: hashed_last_name,
      user_hashed_phone: hashed_phone,
      user_hashed_state: hashed_state,
      user_hashed_user_id: hashed_external_id,
      user_hashed_zip: hashed_zip,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }).filter(([_, value]) => value !== undefined)
  );

  if (Object.keys(payload).length === 0) {
    return null;
  }
  return payload as Record<string, string>;
}
